import React from "react";
import Sidebar from "../components/Sidebar";
import "../styles/Auth.css"; // Import your styles
import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom

const Register = () => {
  const navigate = useNavigate();

  const handleToggle = () => {
    navigate("/login");
  };

  return (
    <div className="content">
      <Sidebar />
      <div className="main-content">
        <div className="Register">
          <h1>ISN NETWORK</h1>
          <h1>Register for ISN Network</h1>
          <div className="auth-box">
            <form className="auth-form">
              <input
              type="text"
              placeholder="Username"
              className="auth-input"
              required
            />
            <input
              type="email"
              placeholder="Email"
              className="auth-input"
              required
            />
            <input
              type="password"
              placeholder="Password"
              className="auth-input"
              required
            />
              <button type="submit" className="auth-button">
                Register
              </button>
            </form>
            <p className="auth-toggle" onClick={handleToggle}>
              Already have an account? Log in here
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;

